var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslateSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.8 7.999a7.2 7.2 0 1114.4 0 7.2 7.2 0 01-14.4 0z",
    fill: "#5FC375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 7.6l2.133 2 4.267-4",
    stroke: "#fff",
    strokeWidth: 0.96,
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNzk5ODA1IDcuOTk4NzlDMC43OTk4MDUgNC4wMjIzNiA0LjAyMzM0IDAuNzk4ODI4IDcuOTk5NzYgMC43OTg4MjhDMTEuOTc2MiAwLjc5ODgyOCAxNS4xOTk3IDQuMDIyMzYgMTUuMTk5NyA3Ljk5ODc5QzE1LjE5OTcgMTEuOTc1MiAxMS45NzYyIDE1LjE5ODcgNy45OTk3NiAxNS4xOTg3QzQuMDIzMzQgMTUuMTk4NyAwLjc5OTgwNSAxMS45NzUyIDAuNzk5ODA1IDcuOTk4NzlaIiBmaWxsPSIjNUZDMzc1Ii8+CjxwYXRoIGQ9Ik00LjgwMDA1IDcuNTk5NjFMNi45MzMzOCA5LjU5OTYxTDExLjIgNS41OTk2MSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIwLjk2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgTranslateSuccess as ReactComponent };